import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Box } from "signoxe/components/layout";
import {
  Button,
  Popup,
  Icon,
  Switch,
  FeedPopup,
} from "signoxe/components/widgets";
import "./styles.scss";

import {
  toggleDeviceId,
  updateDeviceGroup,
  updateContentFeed,
  fetchDeviceGroups,
  confirmationRequest,
} from "signoxe/actions";
import {
  CONTENT_FEEDS_RESOURCE,
  DEVICE_GROUPS_RESOURCE,
  DEVICES_RESOURCE,
} from "signoxe/api/resources";
import { API_ROOT } from "signoxe/constants/config";
import { getAuthTokenHeader } from "signoxe/actions/remote";

import { getDeviceGroup, getDeviceGroupWraper, getProfile } from "signoxe/selectors";

import { callOnEnter } from "signoxe/utils/eventHelpers";

import { updateProfile } from "signoxe/actions";

import { ContentFeedView } from "signoxe/components";

import { OrientationSelectWidget } from "signoxe/components/widgets/OrientationSelectWidget";
import { TransitionSelectWidget } from "signoxe/components/widgets/TransitionSelectWidget";
import { OpenUrlSelectWidget } from "signoxe/components/widgets/OpenUrlSelectWidget";

class ContentModal extends React.Component {
  constructor(props) {
    super(props);
    const { id, toggleDeviceId, state } = this.props;
    if (id) {
      if(getDeviceGroup(state, id) == undefined){
        const deviceGroup = getDeviceGroupWraper(state, id);
      }else{
        const deviceGroup = getDeviceGroup(state, id);
      } 
      let syncPeriodicityValue = 0;
      let syncPeriodicityMultiplier = 60;
      // const deviceGroup = this.props.deviceGroup;
      const syncPeriodSeconds = (deviceGroup.feed && deviceGroup.feed.group_sync_period_seconds) || 0;
      if (syncPeriodSeconds > 0) {
        let remainder = syncPeriodSeconds % 3600;
        if (remainder > 0) {
          syncPeriodicityValue = Math.floor(syncPeriodSeconds / 60);
          syncPeriodicityMultiplier = 60;
        } else {
          syncPeriodicityValue = Math.floor(syncPeriodSeconds / 3600);
          syncPeriodicityMultiplier = 3600;
        }
      }

    }
    this.state = {
      showPriorityMessage: false,
      syncPeriodicityValue: 0,
      syncPeriodicityMultiplier: 60,
      showDevices: true
    };
  }
  static propTypes = {
    visible: PropTypes.bool.isRequired,
  };

  handleSubmitTouchSettings = (id, newFeed) =>
    this.props.updateContentFeed(id, newFeed);

  handleDeviceGroupChange = (id, newGroup) =>{
    this.props.updateDeviceGroup(id, newGroup);
  }

  handleGroupFeedChange = (id, newFeed) =>{
    this.props.updateContentFeed(id, newFeed);
  }

  addFeed(id) {
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: getAuthTokenHeader(),
      },
      credentials: "same-origin",
    };
    return fetch(
      `${API_ROOT}${DEVICE_GROUPS_RESOURCE}/${id}/feeds/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((feed) => this.props.fetchDeviceGroups(id));
  }

  deleteFeed(feed) {

    this.props.confirmationRequest(
      "Deleting Content Feed",
      `Deleting the content feed is permanent and cannot be undone.`,
      "DELETE",
      CONTENT_FEEDS_RESOURCE,
      feed.id,
      feed.channel.id
    );
  }

  componentDidMount() {
    const toggleDeviceId = this.props.toggleDeviceId;
    window.onkeydown = function (event) {
      var isEscape = false;
      if ("key" in event) {
        isEscape = event.key === "Escape" || event.key === "Esc";
      } else {
        isEscape = event.keyCode === 27;
      }

      if (isEscape) {
        toggleDeviceId(null);
      }
    };
  }

  handleChange = (field, feed) => (e) => {
    if (e.currentTarget.value >= 0) {
      this.handleGroupFeedChange(feed.id, {
        [field]: field.includes("duration")
          ? e.currentTarget.value * 1000
          : e.currentTarget.value,
      });
    }
  }

  handleChangSelect = (field, feed) => (e) => {
    if (e.target.value >= 0) {
      this.handleGroupFeedChange(feed.id, {
        [field]: field.includes("duration")
          ? e.target.value * 1000
          : e.target.value,
      });
    }
  }

  handleIdleTimeChange = (field, feed) => (e) => {
    if (e.currentTarget.value >= 0) {
      this.handleGroupFeedChange(feed.id, {
        [field]: field.includes("url")
          ? e.currentTarget.value
          : e.currentTarget.value,
      });
    }
  }

  handleTouchChange = (field, feed) => (e) => {
    this.handleSubmitTouchSettings(feed.id, {
        [field]: e.currentTarget.value,
      });
    }
  

  render() {
    const { id, toggleDeviceId, state } = this.props;

    if (id) {
      if(getDeviceGroup(state, id) == undefined){
        const deviceGroup = getDeviceGroupWraper(state, id);
      }else{
        const deviceGroup = getDeviceGroup(state, id);
      }
      const { profile } = this.props;
      const multiRegionEnabled =
        profile &&
        profile.features &&
        profile.features.multiregion &&
        localStorage.getItem("multiregion_switch") == "true";

      return (
        <FeedPopup
          className="feed-content-popup"
          title={`Update Content Feed`}
          modal
          cb={
            profile && profile.features && profile.features.multichannel !== undefined
              ? () => this.addFeed(deviceGroup.id)
              : null
          }
          toggleDeviceId={toggleDeviceId}


        >
          <div className="modal-container">
            <Box
              className="modal-wrapper"
              direction="column"
              justifyContent="center"
            >
              {profile && profile.features && profile.features.conditional_playback && !multiRegionEnabled ? (
                <Box direction="column" className="device-group-playback">
                  <Switch
                    className="switch-label-mb"
                    checked={deviceGroup.conditional_playback_switch}
                    formId="conditional-playback"
                    label="Conditional Playback"
                    size="medium"
                    onChange={(e) => {
                      // this.props.updateProfile(profile.username, {
                      //   conditional_playback_switch: e.currentTarget.checked,
                      // });
                      this.handleDeviceGroupChange(deviceGroup.id, {
                        conditional_playback_switch: e.currentTarget.checked,
                      });
                      if (!e.currentTarget.checked) {
                        this.props.updateContentFeed(deviceGroup.feed.id, {
                          frequency: -1,
                          number_of_item_to_play: 1,
                          max_play_count: -1,
                        });
                      }
                    }}
                    className="conditional-playback"
                  />
                </Box>
              ) : null}
              {(deviceGroup && deviceGroup.schedule.present) ||
                (profile && profile.features && profile.features.multichannel) ? (
                <React.Fragment>
                  <Box direction="column" className="feed-list">
                    <Box
                      direction="row"
                      alignItems="center"
                      className="device-group-config"
                      wrap
                    >
                      <ContentFeedView
                        profile={this.props.profile}
                        deviceTags={this.props.deviceTags}
                        handleUserReport={this.props.handleUserReport}
                        deviceGroup={deviceGroup}
                        feed={deviceGroup.feed}
                        onChange={this.handleGroupFeedChange}
                        first={true}
                        onDeviceGroupChange={this.props.onDeviceGroupChange}
                      />
                    </Box>

                    {deviceGroup.feed_chain
                      .filter((feed) => feed.id !== deviceGroup.feed.id)
                      .map((feed) => (
                        <Box
                          direction="row"
                          alignItems="center"
                          className="device-group-config"
                          wrap
                        >
                          <ContentFeedView
                            profile={this.props.profile}
                            deviceTags={this.props.deviceTags}
                            handleUserReport={this.props.handleUserReport}
                            deviceGroup={deviceGroup}
                            feed={feed}
                            onChange={this.handleGroupFeedChange}
                            hideDurations={true}
                            hideOrientationSelection={true}
                            hideOverlayTickers={true}
                            first={false}
                            onDeviceGroupChange={this.props.onDeviceGroupChange}
                          />
                          {/* <Icon
                            name="cog"
                            color=" #416464 "
                            size="2rem"
                            title="Setting Feed"
                            onClick={() => this.deleteFeed(feed)}
                          /> */}
                          <Icon
                            className="hide-for-desktop gapIcon"
                            name="trash-o"
                            color=" #416464 "
                            size="1.3rem"
                            margin="9px 39px 0px 3px"
                            title="Remove Feed"
                            hoverColor="red"
                            onClick={() => this.deleteFeed(feed)}
                          />

                          <Icon
                            className="hide-for-mobile  gapIcon"
                            name="trash-o"
                            color=" #416464 "
                            size="1.3rem"
                            title="Remove Feed"
                            hoverColor="red"
                            onClick={() => this.deleteFeed(feed)}
                          />
                        </Box>
                      ))}
                  </Box>
                </React.Fragment>
              ) : (
                <Box
                  direction="row"
                  alignItems="center"
                  className="device-group-config"
                  wrap
                >
                  
                  <ContentFeedView
                    profile={this.props.profile}
                    deviceTags={this.props.deviceTags}
                    handleUserReport={this.props.handleUserReport}
                    deviceGroup={deviceGroup}
                    feed={deviceGroup.feed}
                    onChange={this.handleGroupFeedChange}
                    onDeviceGroupChange={this.props.onDeviceGroupChange}
                  />
                  {/* <Switch checked={deviceGroup.display_date_time}
                    formId={`show-time-${deviceGroup.id}`}
                    label="Show Time"
                    size="tiny"
                    onChange={({ currentTarget }) =>
                      this.handleDeviceGroupChange(deviceGroup.id, { display_date_time: currentTarget.checked })
                    }
                  /> */}
                </Box>
              )}
              <Box direction="column" className="other-group-settings">
                <h4>Other Group Settings</h4>
              </Box>

              <Box direction="column" className="device-group-actions" wrap>
                <Switch
                  checked={deviceGroup.display_date_time}
                  formId={`show-time-${deviceGroup.id}`}
                  label="Show Time"
                  size="tiny"
                  onChange={({ currentTarget }) => {
                    this.props.handleUserReport(`Enabled/Disabled Show Time for ${deviceGroup.name}`)
                    this.handleDeviceGroupChange(deviceGroup.id, {
                      display_date_time: currentTarget.checked,
                    })
                  }
                  }
                />
                <Switch
                  label="Stretching"
                  checked={deviceGroup.stretching}
                  formId={`stretching-${deviceGroup.id}`}
                  size="tiny"
                  onChange={({ currentTarget }) => {
                    this.props.handleUserReport(`Enabled/Disabled stretching for ${deviceGroup.name}`)
                    this.handleDeviceGroupChange(deviceGroup.id, {
                      stretching: currentTarget.checked,
                    })
                  }
                }
                />
                {profile && profile.features && profile.features.allow_ai_Sense ? (
                  <>
                    <Switch
                      label="AI Sense (For Images)"
                      checked={deviceGroup.ai_Sense}
                      formId={`ai_Sense-${deviceGroup.id}`}
                      size="tiny"
                      onChange={({ currentTarget }) =>
                        this.handleDeviceGroupChange(deviceGroup.id, {
                          ai_Sense: currentTarget.checked,
                        })
                      }
                    />
                  </>
                ): null}
                <Switch
                  label="Show Caption"
                  checked={deviceGroup.caption}
                  formId={`caption-${deviceGroup.id}`}
                  size="tiny"
                  onChange={({ currentTarget }) => {
                    this.props.handleUserReport(`Enabled/Disabled caption for ${deviceGroup.name}`)
                    this.handleDeviceGroupChange(deviceGroup.id, {
                      caption: currentTarget.checked,
                    })
                  }

                }
                />
                <Switch
                  label="App Auto Focus"
                  checked={deviceGroup.app_auto_focus}
                  formId={`app_auto_focus-${deviceGroup.id}`}
                  size="tiny"
                  onChange={({ currentTarget }) => {
                    this.props.handleUserReport(`Enabled/Disabled app_auto_focus for ${deviceGroup.name}`)
                    this.handleDeviceGroupChange(deviceGroup.id, {
                      app_auto_focus: currentTarget.checked,
                    })
                  }

                }
                />

              {profile && profile.features && profile.features.touch_controls ? <Switch
                  label="Touch Control"
                  checked={deviceGroup.touch_control}
                  formId={`touch_control-${deviceGroup.id}`}
                  size="tiny"
                  onChange={({ currentTarget }) => {
                    this.props.handleUserReport(`Enabled/Disabled Touch Control for ${deviceGroup.name}`)
                    this.handleDeviceGroupChange(deviceGroup.id, {
                      touch_control: currentTarget.checked,
                    })
                  }

                }
                />:null}

                {profile && profile.features && profile.features.transition && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "10px" }}>Transitions</span>
                    <TransitionSelectWidget
                      profile={profile}
                      feed={deviceGroup.feed}
                      condition={deviceGroup.conditional_playback_switch && !multiRegionEnabled}

                    />
                  </div>
                )}

                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "10px" }}>Orientation</span>{" "}
                  <OrientationSelectWidget
                    profile={profile}
                    feed={deviceGroup.feed}
                  />
                </div>
              </Box>
              <div style={{ marginTop: "10px" }}>

                <Box direction="row" alignItems="center">
                  <span style={{ marginRight: "-27px" }}>Assest Type Default time(s) </span>{" "}


                  <Box direction="row" alignItems="center" className="input-sizes-mainbox">

                    <label style={{ marginRight: "3px", fontSize: "0.7rem", fontWeight: "400" }}>
                      Images/Docs
                      <input
                        id="image-duration"
                        name="image-duration"
                        type="text"
                        className="input-size"
                        defaultValue={deviceGroup.feed.image_duration / 1000}
                        placeholder="Default Image time (s)"
                        title="Default duration for images (s)"
                        onBlur={this.handleChange("image_duration", deviceGroup.feed)}
                        onKeyDown={callOnEnter(
                          this.handleChange("image_duration", deviceGroup.feed)
                        )}
                      />
                    </label>

                    <label style={{ marginRight: "1px", fontSize: "0.7rem", fontWeight: "300" }}>
                      Video
                      <input
                        id="video-duration"
                        name="video-duration"
                        type="text"
                        className="input-size"
                        defaultValue={deviceGroup.feed.video_duration <= 0 ? "" : deviceGroup.feed.video_duration / 1000}
                        title="Blank implies video duration"
                        onBlur={this.handleChange("video_duration", deviceGroup.feed)}
                        onKeyDown={callOnEnter(
                          this.handleChange("video_duration", deviceGroup.feed)
                        )}
                      />
                    </label>


                    <label style={{ marginRight: "1px", fontSize: "0.7rem", fontWeight: "300" }}>
                      URL
                      <input
                        id="url-duration"
                        name="url-duration"
                        type="text"
                        className="input-size"
                        defaultValue={deviceGroup.feed.url_duration < 0 ? 0 : deviceGroup.feed.url_duration / 1000}
                        placeholder="Default url time (s)"
                        title="Blank implies URL does not auto refresh"
                        onBlur={this.handleChange("url_duration", deviceGroup.feed)}
                        onKeyDown={callOnEnter(
                          this.handleChange("url_duration", deviceGroup.feed)
                        )}
                      />
                    </label>
                    <label style={{ fontSize: "0.7rem", fontWeight: "300" }}>
                      {" "}
                      Others
                      <input
                        id="web-duration"
                        name="web-duration"
                        type="text"
                        className="input-size"
                        defaultValue={deviceGroup.feed.web_duration / 1000}
                        placeholder="Default Web time (s)"
                        title="Default duration for web content (s)"
                        onBlur={this.handleChange("web_duration", deviceGroup.feed)}
                        onKeyDown={callOnEnter(
                          this.handleChange("web_duration", deviceGroup.feed)
                        )}
                      />
                    </label>
                  </Box>
                </Box>

              </div>

              {profile && profile.features && profile.features.urlTouchSetting && (

                <Box direction="column" className="device-group-actions" wrap>
                  <Box direction="column" className="other-group-settings">
                    <h4>Touch Settings</h4>
                  </Box>

                  <Box direction="column" className="other-group-settings">
                  </Box>
                  <div style={{ display: "flex", alignItems: "start", jusitfyContent: "start" }}>

                    <span style={{ marginTop: "0.5rem", marginRight: "0.2rem" }} >
                      Touch URL:</span>
                    <input
                      style={{ width: "70%" }}
                      id="touch-url"
                      name="touch-url"
                      type="url"
                      placeholder="Enter url here"
                      defaultValue={deviceGroup.feed.touch_url}
                      onBlur={this.handleTouchChange("touch_url", deviceGroup.feed)}
                      onKeyDown={callOnEnter(
                        this.handleTouchChange("touch_url", deviceGroup.feed)
                      )}
                    />
                  </div>

                  <div style={{ display: "flex", alignItems: "start", jusitfyContent: "start" }}>
                    <span style={{ marginTop: "0.5rem", marginRight: "0.2rem" }} >
                      Idle Time(s):</span>
                    <input
                      style={{ width: "70%" }}

                      id="idle-time-for-url"
                      name="idle-time-for-url"
                      type="text"
                      placeholder="Enter Idle Time"
                      defaultValue={deviceGroup.feed.idle_time_url > 0 ? deviceGroup.feed.idle_time_url : 0}
                      onBlur={this.handleIdleTimeChange("idle_time_url", deviceGroup.feed)}
                      onKeyDown={callOnEnter(
                        this.handleIdleTimeChange("idle_time_url", deviceGroup.feed)
                      )}
                    />
                  </div>


                  <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                    <span style={{ marginRight: "9px" }}>Open URL on:</span>{" "}
                    <OpenUrlSelectWidget
                      profile={profile}
                      feed={deviceGroup.feed}
                    />
                  </div>

                </Box>)
              }


              {profile && profile.group_sync_switch && (

                <Box direction="column" className="device-group-actions" wrap>
                  <Box direction="column" className="other-group-settings">
                    <h4>Sync Settings</h4>
                  </Box>

                  <Box direction="column" className="other-group-settings">
                  </Box>
                  <Box direction="row" alignItems="start" justifyContent="start">
                    <span style={{ marginTop: "0.5rem", marginRight: "0.2rem" }} >
                      NTP Server1:</span>
                    <input
                      style={{ width: "70%" }}
                      id="ntp-server-1"
                      name="ntp-server-1"
                      type="url"
                      placeholder="Enter url here"
                      defaultValue={deviceGroup.feed.ntp_server_url}
                      onBlur={this.handleChange("ntp_server_url", deviceGroup.feed)}
                      onKeyDown={callOnEnter(
                        this.handleTouchChange("ntp_server_url", deviceGroup.feed)
                      )}
                    />
                  </Box>


                  <Box direction="row" alignItems="start" justifyContent="start" >
                    <span style={{ marginTop: "0.5rem", marginRight: "0.2rem" }} >
                      NTP Server2:</span>
                    <input
                      style={{ width: "70%" }}
                      id="ntp-server-2"
                      name="ntp-server-2"
                      type="text"
                      placeholder="Enter Url Here"
                      defaultValue={deviceGroup.feed.ntp_server_url2}
                      onBlur={this.handleChange("ntp_server_url2", deviceGroup.feed)}
                      onKeyDown={callOnEnter(
                        this.handleTouchChange("ntp_server_url2", deviceGroup.feed)
                      )}
                    />
                  </Box>


                  <Box className="sync-periodicity-container">
                    <span style={{ whiteSpace: 'nowrap', lineHeight: 2.6, marginRight: 8 }}>Sync Periodicity:</span>
                    <input
                      type="number" style={{ marginBottom: 0, width: 60 }} value={this.state.syncPeriodicityValue}
                      onChange={event => {
                        this.setState({ syncPeriodicityValue: event.target.value });
                        this.handleGroupFeedChange(deviceGroup.feed.id, {
                          group_sync_period_seconds: event.target.value * this.state.syncPeriodicityMultiplier
                        });
                      }}
                    />
                    <select
                      style={{ marginBottom: 0 }} value={this.state.syncPeriodicityMultiplier}
                      onChange={event => {
                        this.setState({ syncPeriodicityMultiplier: event.target.value });
                        this.handleGroupFeedChange(deviceGroup.feed.id, {
                          group_sync_period_seconds: this.state.syncPeriodicityValue * event.target.value
                        });
                      }}
                    >
                      <option value={60}>minutes</option>
                      <option value={3600}>hours</option>
                    </select>
                  </Box>

                </Box>)
              }


              <Button
                style={{ marginBottom: "2rem", marginTop: "1rem" }}
                className="exit-btn"
                primary
                onClick={() => toggleDeviceId(null)}
              >
                Exit
              </Button>

            </Box>
          </div>


        </FeedPopup>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    profile: getProfile(state),
  };
};

export default connect(mapStateToProps, {
  toggleDeviceId,
  updateDeviceGroup,
  updateContentFeed,
  fetchDeviceGroups,
  confirmationRequest,
  updateProfile,
})(ContentModal);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ContentModal/index.js